var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('TaskTypeForm',{attrs:{"taskTypeId":_vm.taskTypeId},on:{"done":_vm.onDone}})}
var staticRenderFns = []

export { render, staticRenderFns }